<template>
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div class="box-layout-inner" :class="{ 'alert-child': alert }">
            <div class="title-block-alt acc-child">
                <span v-html="full_name"></span>
            </div>

            <div class="content-block">
                <div class="course-blocks">

                    <div class="course-details">
                        <span>{{ locale.text_date_of_birth_prefix + date_of_birth }}</span>
                        <span>{{ locale.text_next_on_camp_prefix }}</span>
                        <b v-if="participant.attending_camp.next.date != null" v-html="participant.attending_camp.next.date.toDate().toDateString()"></b>
                        <b v-else>{{ locale.text_no_future_bookings }}</b>
                    </div>

                    <div class="meta-links">
                        <router-link id="updateChild" :to="{name: 'account.children.update', params: { id: participant.id } }">{{ locale.button_update_child_details }}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['participant', 'alert'],
        data () {
            return {
                attendance: 0,
            }
        },
        computed: {
            full_name: function () {
                return [this.participant.first_name, this.participant.last_name].join(' ');
            },
            date_of_birth: function () {
                return this.participant.dob.toDate().toShortDateString(true, '-', 'short', true);
            },
            locale: function () {
                return this.$root.locale.account.children;
            }
        },
        methods: {
            remove: function () {
                //Handle participant remove
                axios.delete('/camp-booking/participants/'+this.participant.id)
                    .then(response => {
                        if(response.data.status == 'success') {
                            this.$root.alert('Child has been deleted', 'success');
                            this.$emit('removed');
                        }
                    })
            },
        },
    }
</script>



// WEBPACK FOOTER //
// ChildBlock.vue?6b703303